module.exports = __webpack_public_path__ + "img/pngsd_logo.5c7ec48f.png";